'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import keyMirror from 'react-utils/keyMirror';
import { findKey } from 'underscore';
import CustomWidgetTags from 'ContentUtils/constants/CustomWidgetTags';
import CustomWidgetTagGroups from 'ContentUtils/constants/CustomWidgetTagGroups';
var TAG_KEYS_MAP = CustomWidgetTagGroups.FUNCTIONS.reduce(function (hash, tag) {
  var tagKey = findKey(CustomWidgetTags, function (_tag) {
    return _tag === tag;
  });
  return Object.assign({}, hash, _defineProperty({}, tagKey, null));
}, {});
export default keyMirror(Object.assign({}, TAG_KEYS_MAP, {
  NONE: null
}));